import type { ButtonHTMLAttributes, ReactNode } from 'react'

import {
  getButtonClassName,
  type ButtonVariant,
  type OutlineTone,
  type PrimaryWeight,
} from './buttonVariants'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  fullWidth?: boolean
  loading?: boolean
  loadingLabel?: ReactNode
  primaryWeight?: PrimaryWeight
  outlineTone?: OutlineTone
  active?: boolean
}

export function Button({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  loadingLabel,
  primaryWeight = 'semibold',
  outlineTone = 'auth',
  active = false,
  disabled,
  className = '',
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  const isDisabled = disabled || loading
  const content = loading && loadingLabel != null ? loadingLabel : children

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={getButtonClassName({
        variant,
        fullWidth,
        primaryWeight,
        outlineTone,
        active,
        className,
      })}
      {...rest}
    >
      {content}
    </button>
  )
}

export default Button
